module.exports = __webpack_public_path__ + "static/media/big.6c6502ba.svg";